import React, { useState } from "react"
import { Redirect, Route, withRouter } from "react-router-dom"
import { Button, Container, Grid } from "semantic-ui-react"
import { useStore } from "store"
import "./Overview.css"
import "./Agreement.css"

export const Agreement = props => {
  const [accepted, toggleAccepted] = useState(false)
  const {
    agreementTitle,
    nextUrl,
    id,
    created_at,
    acceptAgreement,
    isSignin,
    is_new,
    isModal = false
  } = props
  const [content] = useStore("agreementTexts", id)
  const createdAtDate = created_at ? new Date(created_at) : null
  const statusText = is_new ? "new" : "updated"
  const createdAtText = createdAtDate
    ? `${createdAtDate.toLocaleString("en-US", {
        month: "long"
      })} ${createdAtDate.getDate()}, ${createdAtDate.getFullYear()}`
    : ""

  if (accepted) {
    return <Redirect to={nextUrl} />
  }
  return (
    <Container textAlign="center" className="white">
      <Grid
        className="overview_maindiv"
        style={{ marginTop: "0px", marginBottom: "0px" }}
      >
        {!isModal && (
          <>
            <Grid.Row style={{ paddingBottom: "0px" }}>
              <Grid.Column textAlign="center">
                <h2
                  className="overview__Heading"
                  style={{ fontSize: "24px", marginBottom: "0px" }}
                >
                  {isSignin
                    ? `${statusText[0].toUpperCase()}${statusText.slice(1)} `
                    : ""}
                  {agreementTitle}
                </h2>
                <h4 style={{ marginTop: "0px" }}>{createdAtText}</h4>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row centered style={{ paddingTop: "0px" }}>
              <Grid.Column
                className="overview__Description"
                width={14}
                textAlign="center"
              >
                <p
                  className="overview__DescriptionText"
                  style={{ fontSize: "20px" }}
                >
                  Please review and accept this
                  {isSignin ? ` ${statusText} ` : " "}
                  agreement using the Accept button at the bottom.
                </p>
              </Grid.Column>
            </Grid.Row>
          </>
        )}
        <Grid.Row centered>
          <Grid.Column>
            <div
              className="Agreement"
              dangerouslySetInnerHTML={{ __html: content }}
              style={{ padding: "1em" }}
            />
          </Grid.Column>
        </Grid.Row>
        {!isModal && (
          <Grid.Row columns="equal" className="Footer">
            <Grid.Column textAlign="left">
              <Button
                content="Print"
                primary
                basic
                onClick={() => window.print()}
              />
            </Grid.Column>
            <Grid.Column textAlign="right">
              <Button
                data-testid="accept"
                content="Accept"
                primary
                onClick={() => {
                  acceptAgreement(id)
                  toggleAccepted(true)
                }}
              />
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    </Container>
  )
}

const Agreements = withRouter(
  ({
    agreements,
    match: { url },
    onSuccess,
    onAllAccept,
    onAccept,
    isSignin = false
  }) => (
    <AgreementsContainer
      {...{ onSuccess, url, agreements, onAllAccept, onAccept, isSignin }}
    />
  )
)

class AgreementsContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      acceptedAgreements: props.isSignin
        ? props.agreements
            .filter(({ is_action_completed }) => is_action_completed === true)
            .map(({ id }) => id)
        : props.agreements
            .filter(
              ({ action_required }) => action_required !== ("accept" || "sign")
            )
            .map(({ id }) => id)
    }
  }
  acceptAgreement = id => {
    this.setState({
      acceptedAgreements: [...this.state.acceptedAgreements, id]
    })
    if (this.props.isSignin) {
      this.props.onAccept(id)
    }
  }
  componentWillUnmount = () => {
    if (this.props.onAllAccept)
      this.props.onAllAccept(this.state.acceptedAgreements)
  }

  render = () => {
    const { agreements, onSuccess, url, isSignin } = this.props
    const explicitAgreements = isSignin
      ? agreements.filter(
          ({ is_action_completed, action_required }) =>
            is_action_completed === false &&
            (action_required === "accept" || action_required === "sign")
        )
      : agreements.filter(
          ({ action_required }) =>
            action_required === "accept" || action_required === "sign"
        )
    if (
      explicitAgreements.length === 0 ||
      this.state.acceptedAgreements.length === agreements.length
    ) {
      return <Redirect to={onSuccess} />
    }
    return (
      <div>
        {explicitAgreements
          .map(({ id, created_at, is_new }, index) => {
            const nextAgreement = explicitAgreements[index + 1]
            const nextUrl = nextAgreement
              ? `${url}/${nextAgreement.id}`
              : onSuccess
            const nextTitle = nextAgreement
              ? nextAgreement.title
              : "Create Account"
            const agreementTitle = explicitAgreements.find(
              ({ id: agreementId }) => agreementId === id
            ).title
            return (
              <Route
                key={id}
                path={`${url}/${id}`}
                render={() => (
                  <Agreement
                    {...{
                      nextTitle,
                      nextUrl,
                      isSignin,
                      id,
                      created_at,
                      is_new,
                      agreementTitle,
                      acceptAgreement: this.acceptAgreement
                    }}
                  />
                )}
              />
            )
          })
          .concat(
            <Route
              key="default"
              path={url}
              exact
              render={() => (
                <Redirect to={`${url}/${explicitAgreements[0].id}`} />
              )}
            />
          )}
      </div>
    )
  }
}

export default Agreements
